// extracted by mini-css-extract-plugin
module.exports = {"container":"evaluations_container__Iw_7N","content":"evaluations_content__rhXaT","position":"evaluations_position__j24ed"};